import { render, staticRenderFns } from "./paihang1.vue?vue&type=template&id=404eec55&scoped=true"
import script from "./paihang1.vue?vue&type=script&lang=js"
export * from "./paihang1.vue?vue&type=script&lang=js"
import style0 from "./paihang1.vue?vue&type=style&index=0&id=404eec55&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404eec55",
  null
  
)

export default component.exports